export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
    "imagen" : "assets/imgs/organointernocontrol.jpg",
    "url" : "https://www.facebook.com/share/p/1RoPPRuvp",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "La Contraloría participó en una mesa de trabajo con el Órgano Interno de Control y el Comisario Público de la UICEH, con el objetivo de fortalecer la coordinación y establecer estrategias conjuntas. Sumamos esfuerzos para consolidar una gestión institucional más transparente, ordenada y responsable. #PrimeroElPueblo #CoordinacionInstitucional",
},
{
    "imagen" : "assets/imgs/jaltocan.jpg",
    "url" : "https://www.facebook.com/share/p/1DJ6vSrqU5/",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "El presidente municipal Guillermo Amador Lara presentó su #2doInformeJaltocán, donde compartió los avances y resultados de su administración en favor de las familias y comunidades. En representación del gobernador Julio Menchaca, Briseyda Torres Martínez, directora general de Órganos de Control y Vigilancia, acompañó este ejercicio de rendición de cuentas. #PrimeroElPueblo",
},
{
    "imagen" : "assets/imgs/huasca.jpg",
    "url" : "https://www.facebook.com/share/p/1CFLQaEL4",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "En #Huasca reforzamos la participación ciudadana con capacitación a los Comités de Contraloría Social para la vigilancia de las obras y el uso correcto de los recursos públicos. Con ciudadanía activa, promovemos la transparencia, la honestidad y la rendición de cuentas en beneficio de las familias hidalguenses. #ContraloriaSocial",
},
{
    "imagen" : "assets/imgs/chapulhuacan.jpg",
    "url" : "https://www.facebook.com/share/p/1Cx1sc299i/",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "🦺 En #Chapulhuacán fortalecemos la participación ciudadana mediante la capacitación a los Comités de Contraloría Social y la entrega de kits con cascos y chalecos. Con estas herramientas, impulsamos la vigilancia de las obras públicas y el uso responsable de los recursos. #ElHidalgoQueQueremos #ContraloriaSocial",
},
{
    "imagen" : "assets/imgs/sanfelipeorizatlan.jpg",
    "url" : "https://www.facebook.com/share/p/1ZyRwBhoTQ",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "San Felipe Orizatlán compartió los resultados de su gestión en el #2doInformeSanFelipeOrizatlán, presentado por el presidente municipal Dr. Escamilla. El contralor Álvaro Bardales, en representación del gobernador Julio Menchaca, acompañó este ejercicio de rendición de cuentas. #PrimeroElPueblo",
},
{
    "imagen" : "assets/imgs/eloxochitlan.jpg",
    "url" : "https://www.facebook.com/share/p/1CkwZ1ec9Q",
    "titulo" : "Secretaría de Contraloría Hidalgo",
    "fecha" : "🌱 Eloxochitlán compartió los avances y resultados de su administración en el #2doInformeEloxochitlán, presentado por la alcaldesa Anna Laura Ibarra García. 🤝 El contralor Álvaro Bardales asistió a este ejercicio de rendición de cuentas, que permite conocer las acciones y resultados en favor de las familias del municipio. #PrimeroElPueblo",
},

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]